import { IonContent } from '@ionic/react';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import { useWelcomeBackgroundImage } from '../../hooks/useWelcomeBackgroundImage';

import { PageStyles, PageTitleStyles } from './WelcomeScreen.styles';

export const ScreenWelcome: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Welcome Screen',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const backgroundImageSrc = useWelcomeBackgroundImage();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <PageStyles
      background="none"
      bgImage={
        <div className="bg-image">
          <div className="bg-image-rotate">
            <img
              src={backgroundImageSrc}
              alt="Background"
              className="bg-image-img"
            />
          </div>
          <img
            src="../assets/layout-own-ai/welcome-v2/overlay.png"
            alt="Gradient"
            className="overlay-gradient"
          />
        </div>
      }
      bgImageMask={false}
      bgImageMaskClassName="page-bg-image"
    >
      <IonContent>
        <LogoWithAppName className="app-logo" />

        <PageTitleStyles
          className="page-title"
          component="h1"
          variant="headline-large"
          align="center"
        >
          Create your Own
          <br />
          <UiTypography variant="inherit" color="gradient" component="span">
            AI Girlfriend
          </UiTypography>
        </PageTitleStyles>
      </IonContent>

      <OnboardingFooter
        buttonClassName="page-footer-button"
        onContinue={handleNextStep}
        buttonText="Get started"
        buttonSize={'large'}
      />
    </PageStyles>
  );
};
